module.exports = __webpack_public_path__ + "img/roadmap-phase-1-cell-4-icon.6186251c.svg";